import { Breakpoint } from '../../theme';
import fluidGridColumns from '../../theme/fluidGridColumns';
import { GridItemProps } from '../Grid';

export const aboveHeadingGridItemProps: GridItemProps = {
  desktop: 7,
  tabletLandscape: 7,
  tabletPortrait: fluidGridColumns.tabletPortrait,
  mobile: fluidGridColumns.mobile,
};

export const imageGridItemProps = (
  noOfSections: number,
  forceUseAllColumns: boolean | undefined,
  forceLargeImageOnTablet: boolean | undefined
): GridItemProps => {
  switch (noOfSections) {
    case 1:
      return {
        desktop: forceUseAllColumns ? 6 : 5,
        tabletLandscape: forceUseAllColumns ? 6 : 5,
        tabletPortrait: forceLargeImageOnTablet ? fluidGridColumns.tabletPortrait : 3,
        mobile: fluidGridColumns.mobile,
      };
    case 2:
      return {
        desktop: 4,
        tabletLandscape: 4,
        tabletPortrait: 3,
        mobile: fluidGridColumns.mobile,
      };
    default:
      throw Error('Unexpected number of sections for image!');
  }
};

export const sectionsGridItemProps = (
  noOfSections: number,
  forceUseAllColumns: boolean | undefined,
  forceLargeImageOnTablet: boolean | undefined
): GridItemProps => {
  switch (noOfSections) {
    case 1:
      return {
        desktop: forceUseAllColumns ? 6 : 5,
        tabletLandscape: forceUseAllColumns ? 6 : 5,
        tabletPortrait: forceLargeImageOnTablet ? fluidGridColumns.tabletPortrait : 5,
        mobile: fluidGridColumns.mobile,
      };
    case 2:
      return {
        desktop: 8,
        tabletLandscape: 8,
        tabletPortrait: 5,
        mobile: fluidGridColumns.mobile,
      };
    case 3:
      return {
        desktop: 12,
        tabletLandscape: 12,
        tabletPortrait: 6,
        mobile: fluidGridColumns.mobile,
      };
    case 4:
      return {
        desktop: 5,
        tabletLandscape: 5,
        tabletPortrait: fluidGridColumns.tabletPortrait,
        mobile: fluidGridColumns.mobile,
      };
    default:
      throw Error('Unexpected number of sections!');
  }
};

export const displayHeadingInline = (
  noOfSections: number,
  breakpoint: Breakpoint
): boolean =>
  noOfSections !== 4 &&
  (noOfSections === 1 ||
    breakpoint === 'tabletPortrait' ||
    (noOfSections !== 2 && breakpoint === 'mobile'));
